import {useDisclosure} from '@mantine/hooks';
import {parseCookies} from 'nookies';
import {MdAddCircleOutline} from 'react-icons/md';
import {COLOR_SUCCESS_1, COLOR_WHITE} from '../../config/constants/colorCodes';
import {isReleasedRedesignRecruitment} from '../../config/unReleasePage';
import {validateCookie} from '../../core/usecases/auth/checkOauthTokenExistence';
import {useHandleFollowingCommunityTopic} from '../../core/usecases/useHandleLikeCommunityTopic';
import {cn} from '../../lib/classname';
import {NoLoginAlertModal} from './NoLoginAlertModal';

type Props = {
  topicId: number;
  isFollowedInitial: boolean;
  followCountInitial: number;
};

export const FollowCommunityTopicButton: React.FC<Props> = ({
  topicId,
  isFollowedInitial,
  followCountInitial,
}: Props) => {
  const cookies = parseCookies();
  const {isValid} = validateCookie(cookies);

  const [opened, {open, close}] = useDisclosure(false);
  const {isFollowed, followCount, handleFollowingCommunityTopic} =
    useHandleFollowingCommunityTopic({
      topicId,
      isFollowedInitial,
      followCountInitial,
    });

  if (isReleasedRedesignRecruitment()) {
    return (
      <button
        className={cn(
          'border-collapse border-[1px] border-success-1 rounded-16',
          'py-[3px] pl-20 pr-4  w-[55px]',
          'relative flex justify-center items-center hover:opacity-80',
          {
            'bg-success-1 text-white': isFollowed,
            'bg-white text-success-1': !isFollowed,
          },
        )}
        onClick={async () => {
          if (!isValid) {
            open();
            return;
          }

          return handleFollowingCommunityTopic();
        }}
        type="button"
      >
        <sup className="text-base absolute top-[5px] left-4">
          <MdAddCircleOutline
            fill={isFollowed ? COLOR_WHITE : COLOR_SUCCESS_1}
          />
        </sup>
        <span className="text-sm leading">{followCount}</span>
      </button>
    );
  }

  return (
    <>
      <button
        className={`border-collapse border-[1px] border-success-1 rounded-4 ${isFollowed ? 'bg-success-1 text-white' : 'bg-white text-success-1'} py-[3px] pl-20 pr-4 relative w-[55px] flex justify-center items-center hover:opacity-80`}
        onClick={async () => {
          if (!isValid) {
            open();
            return;
          }

          return handleFollowingCommunityTopic();
        }}
      >
        <sup className="text-base absolute top-[5px] left-4">
          <MdAddCircleOutline
            fill={isFollowed ? COLOR_WHITE : COLOR_SUCCESS_1}
          />
        </sup>
        <span className="text-sm leading">{followCount}</span>
      </button>
      <NoLoginAlertModal opened={opened} onClose={close} />
    </>
  );
};
